module.exports = __webpack_public_path__ + "static/media/kiran_core.d2606498.jpg";